import { doc, DocumentReference, Firestore } from 'firebase/firestore'
import FirestoreUser from '../types/FirestoreUser'
import { getEffectiveServices } from './firebaseServiceContext'

export default (
  uid: string,
  firestore: Firestore = getEffectiveServices().firestore,
) =>
  doc(firestore, 'users', uid) as DocumentReference<FirestoreUser>
